import React from 'react';
import { Field, useField } from 'formik';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import ErrorMessage from 'hellospa/components/error-message';

import messages from './intl';
import styles from './index.scss';

const Filename = () => {
  const intl = useIntl();
  const [, filenameMeta] = useField({
    type: 'text',
    id: 'filename',
    name: 'filename',
  });

  return (
    <div className={classNames(styles.filenameContainer, {
      [styles.errorFieldContainer]: filenameMeta.touched && filenameMeta.error,
    })}
    >
      <label className={styles.label} htmlFor="filename">
        {intl.formatMessage(messages.filenameLabel)}
      </label>
      <Field
        className={styles.input}
        id="filename"
        name="filename"
        type="text"
        data-qa-ref="fields.filename"
        rows={1} />
      <div
        className={styles.errorContainer}
        role="message-error"
        data-qa-ref="errors.filename"
      >
        <ErrorMessage
          name="filename"
          className={styles.error} />
      </div>
    </div>
  );
};

export default Filename;
